import React from 'react';

/** Pencil-on-document compose icon (matches casting-style reference SVG). */
export function ComposeMessageIcon(props: React.SVGProps<SVGSVGElement>) {
    const { stroke = 'currentColor', ...rest } = props;
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...rest}>
            <path
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
        </svg>
    );
}
